module.exports = "/_next/static/images/6c3a515d8250dd18da2a43bfb6a656d5-double-card@xs-1x.png.webp";